import {
    Box,
    Button,
    Checkbox,
    CheckboxGroup,
    Field,
    Fieldset,
    Flex,
    Grid,
    GridItem,
    HStack,
    Image,
    Input,
    RadioGroup,
    Text,
} from "@chakra-ui/react";
import { React, useContext, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";

import { context } from "@/context/requirementsContext";
import { useLeadingMaps } from "@/hooks/useBuscadorHook";

const DatosGenerales = (props) => {
    const refLocationSearch = useRef(null);
    const autocomplete = useRef(null);
    const [desde_prespuesto, setDesde_prespuesto] = useState(0);
    const [hasta_prespuesto, setHasta_prespuesto] = useState(0);
    const [desde_mantenimiento, setDesde_mantenimiento] = useState(0);
    const [hasta_mantenimiento, setHasta_mantenimiento] = useState(0);
    const [operacion, setOperacion] = useState("Venta");

    const OPERACIONES = ["Venta", "Renta", "Preventa"];
    const PROPIEDADES = [
        {
            value: "Casa",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/casa.webp",
        },
        {
            value: "Casa Duplex",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/duplex.webp",
        },
        {
            value: "Departamento",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/departamento.webp",
        },
        {
            value: "Oficina",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/oficina.webp",
        },
        {
            value: "Consultorio",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/consultorio.webp",
        },
        {
            value: "Bodega",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/bodega.webp",
        },
        {
            value: "Nave Industrial",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/nave.webp",
        },
    ];

    const [mapsObjectData] = useLeadingMaps(autocomplete, refLocationSearch);

    const { addDataGeneral, updateStep, setLocation } = useContext(context);

    //Logic for operation selection variable
    const handleOperationChange = (details) => {
        setOperacion(details.value);
    };

    //Logic for operation selection array
    const [selectedProperties, setSelectedProperties] = useState(["Casa"]);
    const handlePropertyChange = (details) => {
        setSelectedProperties(details);
    };

    const handleSubmit = (e) => {
        setLocation(mapsObjectData);

        let data = [
            { name: "ubicacion", value: mapsObjectData.location },
            {
                name: "presupuesto_min",
                value: desde_prespuesto ? desde_prespuesto : 0,
            },
            {
                name: "presupuesto_max",
                value: hasta_prespuesto ? hasta_prespuesto : 0,
            },
            {
                name: "mantenimiento_min",
                value: desde_mantenimiento ? desde_mantenimiento : 0,
            },
            {
                name: "mantenimiento_max",
                value: hasta_mantenimiento ? hasta_mantenimiento : 0,
            },
            {
                name: "tipo_de_operacion",
                value: operacion,
            },
            { tipo_propiedad_buscada: selectedProperties },
        ];

        addDataGeneral(data);
        updateStep(1);
    };

    const numericFormatStyle = {
        margin: "15px 0px",
        padding: "0.5rem 1.5rem",
        border: "1px solid #e4e4e7",
        borderRadius: "55px",
        outline: "none",
        marginTop: "20px",
    };

    return (
        <Box w="full" mx="auto" maxW="3x1" px={{ base: "2", md: "8" }} mt={4} {...props}>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(e);
                }}
            >
                <Grid
                    templateColumns={{ md: "1fr 1fr", base: "1fr" }}
                    templateRows="auto"
                    gap={{ md: 8, base: 6 }}
                >
                    <GridItem>
                        <Text fontWeight="700" fontSize="xl" mb="4">
                            Tipo de Operación
                        </Text>
                        <RadioGroup.Root
                            value={operacion}
                            onValueChange={handleOperationChange}
                            name="operaciones"
                        >
                            <HStack justifyContent="start">
                                {OPERACIONES.map((value, idx) => (
                                    <RadioGroup.Item
                                        key={idx}
                                        value={value}
                                        as="label"
                                        mb="0"
                                        cursor="pointer"
                                        borderWidth="1px"
                                        borderRadius="full"
                                        boxShadow="md"
                                        textTransform="capitalize"
                                        px={{ md: 5, base: 3 }}
                                        py={{ md: 3, base: 2 }}
                                        transitionDuration=".3s"
                                        _disabled={{
                                            bg: "gray.200",
                                            color: "accent.100",
                                            border: "none",
                                            boxShadow: "none",
                                            cursor: "not-allowed",
                                        }}
                                        _checked={{
                                            bg: "brand.500",
                                            color: "accent.500",
                                            borderColor: "brand.500",
                                        }}
                                        _hover={{ shadow: "lg" }}
                                        _focus={{
                                            boxShadow: "outline",
                                        }}
                                    >
                                        <RadioGroup.ItemHiddenInput />
                                        <RadioGroup.ItemIndicator />
                                        <RadioGroup.ItemText>{value}</RadioGroup.ItemText>
                                    </RadioGroup.Item>
                                ))}
                            </HStack>
                        </RadioGroup.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root height="100%" justifyContent="end" required>
                            <Field.Label
                                htmlFor="ubicacion"
                                fontSize="xl"
                                mb="4"
                                pb="4"
                                fontWeight="700"
                            >
                                Ubicación
                            </Field.Label>
                            <Input
                                id="ubicacion"
                                type="text"
                                ref={refLocationSearch}
                                rounded="full"
                                placeholder="Introduce una ubicación"
                                px={4}
                                py={6}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={{ md: 2, base: 1 }}>
                        <Text fontWeight="700" fontSize="xl" mb="4">
                            Tipo de Propiedad
                        </Text>
                        <Grid
                            templateColumns={{ md: "repeat(7, 1fr)", base: "repeat(2, 1fr)" }}
                            templateRows="auto"
                            gap={{ md: 4, base: 2 }}
                        >
                            <Fieldset.Root>
                                <CheckboxGroup
                                    defaultValue={["Casa"]}
                                    value={selectedProperties} // Pasamos el array de valores controlados
                                    onValueChange={handlePropertyChange} // Pasamos la función de cambio
                                    name="propiedades" // Un nombre para el grupo (accesibilidad)
                                >
                                    <Fieldset.Content>
                                        <HStack gap="6">
                                            {PROPIEDADES.map((obj, idx) => (
                                                <GridItem key={`propiedad_${obj.value}_container`}>
                                                    <Checkbox.Root
                                                        key={`propiedad_${obj.value}_checkbox`}
                                                        value={obj.value}
                                                        as="label"
                                                        mb="0"
                                                        cursor="pointer"
                                                        borderWidth="1px"
                                                        borderRadius="md"
                                                        boxShadow="md"
                                                        w="32"
                                                        h="32"
                                                        px={5}
                                                        py={3}
                                                        transitionDuration=".3s"
                                                        _checked={{
                                                            bg: "brand.500",
                                                            color: "accent.500",
                                                            borderColor: "brand.500",
                                                        }}
                                                        _focus={{
                                                            boxShadow: "outline",
                                                        }}
                                                        _hover={{ shadow: "lg" }}
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        <Checkbox.HiddenInput />
                                                        <Checkbox.Control />
                                                        <Text
                                                            fontWeight="light"
                                                            mb="3"
                                                            fontSize="2xs"
                                                            textTransform="capitalize"
                                                            h="10"
                                                            color="black"
                                                        >
                                                            {obj.value.replaceAll("_", " ")}
                                                        </Text>
                                                        <Image
                                                            src={obj.icon}
                                                            alt={obj.value}
                                                            w="12"
                                                        />
                                                    </Checkbox.Root>
                                                </GridItem>
                                            ))}
                                        </HStack>
                                    </Fieldset.Content>
                                </CheckboxGroup>
                            </Fieldset.Root>
                        </Grid>
                    </GridItem>
                    <GridItem>
                        <Text fontWeight="700" fontSize="xl" mb="4">
                            Presupuesto
                        </Text>
                        <Flex>
                            <Box mr="2">
                                <Field.Root
                                    rounded="full"
                                    py={{ md: "1", base: "2" }}
                                    border="1px"
                                    borderColor="gray.200"
                                >
                                    <Field.Label
                                        htmlFor="desde_prespuesto"
                                        mb="0"
                                        fontSize="sm"
                                        ml={4}
                                    >
                                        Desde
                                    </Field.Label>
                                    <NumericFormat
                                        id="desde_prespuesto"
                                        allowNegative={false}
                                        prefix="$"
                                        style={numericFormatStyle}
                                        thousandSeparator={true}
                                        onInput={(e) => {
                                            setDesde_prespuesto(
                                                e.target.value
                                                    .replaceAll("$", "")
                                                    .replaceAll(",", "")
                                                    .replaceAll(/[A-Za-z]+/g, "")
                                            );
                                        }}
                                    />
                                </Field.Root>
                            </Box>
                            <Box ml="2">
                                <Field.Root
                                    rounded="full"
                                    py={{ md: "1", base: "2" }}
                                    border="1px"
                                    borderColor="gray.200"
                                >
                                    <Field.Label
                                        htmlFor="hasta_prespuesto"
                                        mb="0"
                                        fontSize="sm"
                                        ml={4}
                                    >
                                        Hasta
                                    </Field.Label>
                                    <NumericFormat
                                        id="hasta_prespuesto"
                                        allowNegative={false}
                                        prefix="$"
                                        style={numericFormatStyle}
                                        thousandSeparator={true}
                                        onInput={(e) => {
                                            setHasta_prespuesto(
                                                e.target.value
                                                    .replaceAll("$", "")
                                                    .replaceAll(",", "")
                                                    .replaceAll(/[A-Za-z]+/g, "")
                                            );
                                        }}
                                    />
                                </Field.Root>
                            </Box>
                        </Flex>
                    </GridItem>
                    <GridItem>
                        <Text fontWeight="700" fontSize="xl" mb="4">
                            Mantenimiento
                        </Text>
                        <Flex>
                            <Box key="box_1" mr="2">
                                <Field.Root
                                    rounded="full"
                                    py={{ md: "1", base: "2" }}
                                    border="1px"
                                    borderColor="gray.200"
                                >
                                    <Field.Label
                                        htmlFor="desde_mantenimiento"
                                        mb="0"
                                        fontSize="sm"
                                        ml={4}
                                    >
                                        Desde
                                    </Field.Label>
                                    <NumericFormat
                                        id="desde_mantenimiento"
                                        allowNegative={false}
                                        prefix="$"
                                        style={numericFormatStyle}
                                        thousandSeparator={true}
                                        onInput={(e) => {
                                            setDesde_mantenimiento(
                                                e.target.value === ""
                                                    ? 0
                                                    : e.target.value
                                                          .replaceAll("$", "")
                                                          .replaceAll(",", "")
                                                          .replaceAll(/[A-Za-z]+/g, "")
                                            );
                                        }}
                                    />
                                </Field.Root>
                            </Box>
                            <Box key="box_2" ml="2">
                                <Field.Root
                                    rounded="full"
                                    py={{ md: "1", base: "2" }}
                                    border="1px"
                                    borderColor="gray.200"
                                >
                                    <Field.Label
                                        htmlFor="hasta_mantenimiento"
                                        mb="0"
                                        fontSize="sm"
                                        ml={4}
                                    >
                                        Hasta
                                    </Field.Label>
                                    <NumericFormat
                                        id="hasta_mantenimiento"
                                        allowNegative={false}
                                        prefix="$"
                                        style={numericFormatStyle}
                                        thousandSeparator={true}
                                        onInput={(e) => {
                                            setHasta_mantenimiento(
                                                e.target.value
                                                    .replaceAll("$", "")
                                                    .replaceAll(",", "")
                                                    .replaceAll(/[A-Za-z]+/g, "")
                                            );
                                        }}
                                    />
                                </Field.Root>
                            </Box>
                        </Flex>
                    </GridItem>
                    <GridItem colSpan={{ md: 2, base: 1 }} textAlign="center">
                        <Button
                            rounded="full"
                            colorPalette="brand"
                            bg="brand.500"
                            color="black"
                            border="0"
                            px="16"
                            my="4"
                            _hover={{ bg: "brand.600" }}
                            type="submit"
                        >
                            Siguiente
                        </Button>
                    </GridItem>
                </Grid>
            </form>
        </Box>
    );
};

export default DatosGenerales;
